<template lang="pug">
div
  h1 Game Stats

  version-filter(
    key="versionFilter",
    @change="versionChanged",
    :wildcard="false"
  )
  environment-filter(key="envFilter", @change="envChanged", :wildcard="false")

  .boxes
    key-stat-box(
      title="Total games",
      :value="formatBigNumber(keyStats.totalGames)"
    )
    key-stat-box(
      title="Games this version",
      :value="formatBigNumber(keyStats.gamesThisVersion)"
    )

  h2 Games by playtime (Minutes)
  .box.chart
    bar-chart-inner(
      :data="playtimeHistogramMinutes",
      :is-percentage="true",
      :show-x-labels="true"
    )

  h2 Games by playtime (Minutes, exclusive)
  .box.chart
    bar-chart-inner(
      :data="playtimeHistogramMinutesExclusive",
      :is-percentage="true",
      :show-x-labels="true"
    )

  h2 Games by playtime (Hours)
  .box.chart
    bar-chart-inner(
      :data="playtimeHistogramHours",
      :is-percentage="true",
      :show-x-labels="true"
    )

  h2 Games by playtime (Hours, exclusive)
  .box.chart
    bar-chart-inner(
      :data="playtimeHistogramHoursExclusive",
      :is-percentage="true",
      :show-x-labels="true"
    )
</template>

<script>

import VersionFilter from "../components/VersionFilter";
import EnvironmentFilter from "../components/EnvironmentFilter";
import KeyStatBox from "../components/KeyStatBox";
import BarChartInner from "../components/BarChartInner";
import ApiService from "../services/api";
import {
  formatBigNumber,
  formatSecondsShort,
  formatPercentage
} from "../utils";

export default {
  components: { VersionFilter, EnvironmentFilter, KeyStatBox, BarChartInner },

  data: () => ({
    version: null,
    environment: null,
    keyStats: {
      totalGames: null,
      gamesThisVersion: null
    },

    playtimeHistogramMinutes: null,
    playtimeHistogramMinutesExclusive: null,
    playtimeHistogramHours: null,
    playtimeHistogramHoursExclusive: null,
  }),

  mounted() {
    this.fetchKeyStats();
  },

  methods: {
    formatBigNumber,
    formatSecondsShort,
    formatPercentage,

    versionChanged(version) {
      this.version = version;
    },

    envChanged(env) {
      this.environment = env;
    },

    async fetchKeyStats() {
      this.keyStats = {
        totalGames: null,
        gamesThisVersion: null
      };
      this.playtimeHistogramMinutes = null;
      this.playtimeHistogramHours = null;
      this.playtimeHistogramMinutesExclusive = null;
      this.playtimeHistogramHoursExclusive = null;

      if (!this.version || !this.environment) {
        return;
      }

      console.log("Fetching key stats");


      const payload = {
        version: this.version,
        environment: this.environment,
      };

      this.keyStats.totalGames = (await ApiService.query(`select count(*)::int from games`))[0].count;
      this.keyStats.gamesThisVersion = (await ApiService.query(`select count(*)::int from games where initial_version = ~version and environment = ~environment`, payload))[0].count;


      this.playtimeHistogramMinutes = (await ApiService.query(`
            select x, (
                select count(*)::float / ~totalGames as y from games g where g.playtime >= x * 60 and g.initial_version = ~version and g.environment = ~environment
            ) from generate_series(0, 30) x
        `, { ...payload, totalGames: this.keyStats.gamesThisVersion }));

      this.playtimeHistogramMinutesExclusive = (await ApiService.query(`
            select x, (
                select count(*)::float / ~totalGames as y from games g
                where g.playtime >= x * 60 and g.playtime < (x + 1) * 60 and g.initial_version = ~version and g.environment = ~environment
            ) from generate_series(0, 30) x
        `, { ...payload, totalGames: this.keyStats.gamesThisVersion }));

      this.playtimeHistogramHours = (await ApiService.query(`
            select x, (
                select count(*)::float / ~totalGames as y from games g where g.playtime >= x * 3600 and g.initial_version = ~version and g.environment = ~environment
            ) from generate_series(0, 30) x
        `, { ...payload, totalGames: this.keyStats.gamesThisVersion }));

      this.playtimeHistogramHoursExclusive = (await ApiService.query(`
            select x, (
                select count(*)::float / ~totalGames as y from games g
                where g.playtime >= x * 3600 and g.playtime < (x + 1) * 3600 and g.initial_version = ~version and g.environment = ~environment
            ) from generate_series(0, 30) x
        `, { ...payload, totalGames: this.keyStats.gamesThisVersion }));

    }
  },

  watch: {
    version() {
      this.fetchKeyStats();
    }
  }
}
</script>
